/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ responded: NonNullable<unknown>, total: NonNullable<unknown> }} Mesh_ProgressInputs */



/**
* | output |
* | --- |
* | "{responded}/{total}" |
*
* @param {Mesh_ProgressInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_progress = /** @type {((inputs: Mesh_ProgressInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_ProgressInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.responded}/${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.responded}/${i?.total}`)
});